export default {
  model: {
    'options/style': 'Style',
    'options/space': 'Space',
    'options/color': 'Color',
    'options/light': 'Light',
    'options/material': 'Material',
    'options/custom': 'Custom',
    'role': 'Role',
    'activeStorage/attachment': 'Attachment',
    'application': 'Application',
    'adminUsersRole': 'Admin user',
    'adminUser': 'Admin user',
    'banner': 'Banner',
    'profile': 'Profile',
    'user': 'User',
    'activeStorage/blob': 'Resource',
    'actsAsTaggableOn/tag': 'Tag',
    'page': 'Page',
    'presetPage': 'Preset page',
    'staticPage': 'Static page',
    'customPage': 'Custom page',
    'hotWord': 'Hot word',
    'operationRecord': 'Operation record',
    'option': 'Option',
    'image': 'Image',
    'sampleImage': 'Sample image',
    'roleCore/role': 'Role',
  },
  'options/style': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    type: 'Type',
    name: 'Name',
    position: 'Position',
    prompt: 'Prompt',
    guidanceScale: 'Guidance scale',
    negativePrompt: 'Negative prompt',
    cover: 'Cover',
    creator: 'Creator',
  },
  'options/space': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    type: 'Type',
    name: 'Name',
    position: 'Position',
    prompt: 'Prompt',
    guidanceScale: 'Guidance scale',
    negativePrompt: 'Negative prompt',
    cover: 'Cover',
    creator: 'Creator',
  },
  'options/color': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    type: 'Type',
    name: 'Name',
    position: 'Position',
    prompt: 'Prompt',
    guidanceScale: 'Guidance scale',
    negativePrompt: 'Negative prompt',
    cover: 'Cover',
    creator: 'Creator',
  },
  'options/light': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    type: 'Type',
    name: 'Name',
    position: 'Position',
    prompt: 'Prompt',
    guidanceScale: 'Guidance scale',
    negativePrompt: 'Negative prompt',
    cover: 'Cover',
    creator: 'Creator',
  },
  'options/material': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    type: 'Type',
    name: 'Name',
    position: 'Position',
    prompt: 'Prompt',
    guidanceScale: 'Guidance scale',
    negativePrompt: 'Negative prompt',
    cover: 'Cover',
    creator: 'Creator',
  },
  'options/custom': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    type: 'Type',
    name: 'Name',
    position: 'Position',
    prompt: 'Prompt',
    guidanceScale: 'Guidance scale',
    negativePrompt: 'Negative prompt',
    cover: 'Cover',
    creator: 'Creator',
  },
  'role': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    kind: 'Kind',
    kinds: {
      super: 'Super',
      application: 'Application',
      custom: 'Custom',
    },
    customPermissions: 'Custom permissions',
  },
  'activeStorage/attachment': {
    id: 'ID',
    createdAt: 'Created at',
    signedId: 'Signed',
    contentType: 'Content type',
    filename: 'Filename',
    byteSize: 'Byte size',
    url: 'Url',
  },
  'application': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    desc: 'Desc',
    shareDesc: 'Share description',
    shareTitle: 'Share title',
    wechatApplicationId: 'Wechat application',
    applicationAdminUsersRoleId: 'Application admin users role',
    shareImage: 'Share image',
    logo: 'Logo',
    imageGenerateOptions: 'Image generate options',
    creator: 'Creator',
    posterImage: 'Poster image',
    loginVideo: 'Login video',
  },
  'adminUsersRole': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    roleId: 'Role',
    adminUserId: 'Admin user',
    applicationId: 'Application',
    isBlock: 'Is block',
    role: 'Role',
    application: 'Application',
    adminUser: 'Admin user',
    adminUserAttributes: 'Admin user attributes',
  },
  'adminUser': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    email: 'Email',
    name: 'Name',
    isBlock: 'Is block',
    adminUsersRolesAttributes: 'Admin users roles attributes',
  },
  'banner': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    target: 'Target',
    position: 'Position',
    pagePosition: 'Page position',
    pagePositions: {
      index_top: 'Index top',
    },
    kind: 'Kind',
    kinds: {
      web_link: 'Web link',
      image: 'Image',
      mp_link: 'Mini program link',
      external_mp_link: 'External mp link',
    },
    alt: 'Alt',
    image: 'Image',
  },
  'profile': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    gender: 'Gender',
    genders: {
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
    },
  },
  'user': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    screenName: 'Screen name',
    isBlock: 'Is block',
    profile: 'Profile',
    avatar: 'Avatar',
  },
  'activeStorage/blob': {
    id: 'ID',
    createdAt: 'Created at',
    signedId: 'Signed',
    contentType: 'Content type',
    filename: 'Filename',
    byteSize: 'Byte size',
    url: 'Url',
    tagList: 'Tag list',
  },
  'actsAsTaggableOn/tag': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
  },
  'page': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    slug: 'Slug',
    title: 'Title',
    type: 'Type',
    applicationId: 'Application',
    viewsCount: 'Views count',
    publishedAt: 'Published at',
    wxacode: 'Wxacode',
    content: 'Content',
  },
  'presetPage': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    slug: 'Slug',
    viewsCount: 'Views count',
    content: 'Content',
  },
  'staticPage': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    slug: 'Slug',
    status: 'Status',
    viewsCount: 'Views count',
    wxacode: 'Wxacode',
    content: 'Content',
  },
  'customPage': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    slug: 'Slug',
    default: 'Default',
    miniProgramPath: 'Mini program path',
    publishedAt: 'Published at',
    formalCustomPageId: 'Formal custom page',
    formalCustomPage: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: 'Configs',
  },
  'hotWord': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    position: 'Position',
    applicationId: 'Application',
    application: 'Application',
  },
  'operationRecord': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    operatableType: 'Operatable type',
    operatableId: 'Operatable',
    operatorType: 'Operator type',
    operatorId: 'Operator',
    ipAddress: 'Ip address',
    operator: 'Operator',
    operatable: 'Operatable',
    operationDescription: 'Operation description',
    requestPath: 'Request path',
    requestMethod: 'Request method',
    requestParams: 'Request params',
    previousObject: 'Previous object',
    currentObject: 'Current object',
  },
  'option': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    type: 'Type',
    name: 'Name',
    position: 'Position',
    prompt: 'Prompt',
    guidanceScale: 'Guidance scale',
    negativePrompt: 'Negative prompt',
    cover: 'Cover',
    creator: 'Creator',
  },
  'image': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    failMessage: 'Fail message',
    taskId: 'Task',
    state: 'State',
    states: {
      pending: 'Pending',
      completed: 'Completed',
      failed: 'Failed',
    },
    userId: 'User',
    raw: 'Raw',
    origin: 'Origin',
    results: 'Results',
    user: 'User',
    options: 'Options',
  },
  'sampleImage': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    position: 'Position',
    image: 'Image',
  },
  'roleCore/role': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    kind: 'Kind',
    customPermissions: 'Custom permissions',
  },
}
